<template>
  <div>
    <vue-headful title="Vacature plaatsen" />
    <Header page_title="Vacature plaatsen" />
    <div class="container-fluid app-body">
      <template>
        <div v-if="isPopupVisible" class="popup-container container-fluid">
          <div class="popup">
            {{ popupMessage }}
          </div>
        </div>
      </template>
      <form @change="onFormChange" @submit.prevent="onSubmit">
        <div class="step-question">
          <button type="submit" ref="submit" hidden>submit</button>
          <div ref="step">
            <template v-if="step === 1">
              <register-steps :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="50" currentStep="1" />
              <strong class="sd-title mini right-line"><span class="title-text"><svg-icon icon="marker" /> Locatie</span></strong>
              <div class="form">
                <ul class="list-unstyled">
                  <li v-for="item in locationList" v-bind:key="item.id">
                    <div class="custom-control custom-radio">
                      <input
                          type="radio"
                          class="custom-control-input"
                          v-model="form.address_id"
                          :value="item.id"
                          v-bind:id="`location-` + item.id"
                      />
                      <label
                          class="custom-control-label text-uppercase"
                          v-bind:for="`location-` + item.id"
                      >
                        <span class="d-block" v-if="item.name_location">
                          <span class="d-inline-block mr-1">
                            {{ item.name_location }}
                          </span>
                        </span>
                        <span class="d-block">
                          <span class="d-inline-block mr-1">
                            {{ item.street }}
                          </span>
                          {{ item.street_number }} {{ item.house_addition }}
                        </span>
                        <span class="d-block">
                          <span class="d-inline-block mr-2">
                            {{ item.postal_code }}
                          </span>
                          {{ item.city }}
                        </span>
                      </label>
                    </div>
                  </li>
                  <li v-if="Object.keys(locationList).length > 0">
                    <router-link
                        :to="{ path: '/company/location/add' }"
                        title="Add Location"
                        class="btn btn-add btn-block position-relative"
                    >
                      <div class="icon-wrapper position-absolute">
                        <i class="material-icons">add_circle</i>
                      </div>
                      Voeg nieuwe locatie toe
                    </router-link>
                  </li>
                </ul>
              </div>
            </template>
            <template v-if="step === 2 && subBranch !== '2'">
              <register-steps :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="22" currentStep="2" />
              <div class="sd-title medium" style="margin-bottom: 20px;">
                Hoelang duurt de vacature?
              </div>
              <div class="custom-control custom-radio">
                <input
                    type="radio"
                    value="0"
                    v-model="form.duration_type"
                    class="custom-control-input"
                    v-bind:id="'0'"
                />
                <label class="custom-control-label" v-bind:for="'0'">8 weken of korter</label>
              </div>
                <div class="custom-control custom-radio">
                <input
                    type="radio"
                    v-model="form.duration_type"
                    value="1"
                    class="custom-control-input"
                    v-bind:id="'1'"
                />
                <label class="custom-control-label" v-bind:for="'1'">langer dan 8 weken</label>
              </div>
            </template>
            <template v-if="step === 3 && subBranch !== '2' && form.duration_type === '0'">
              <register-steps :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="33" currentStep="2" />
              <div class="sd-title medium" style="margin-bottom: 20px;">
                <span class="steps">1/2</span>
                {{ questions[2] ? 'Voor welke periode zoekt u een invaller?' : '' }}
              </div>
              <span class="extra-info" style="margin-bottom: 30px;">
                <svg-icon icon="information" />
                Op de volgende pagina kun je de tijden selecteren
              </span>
              <p class="mb-2">
                <strong>Selecteer 8 weken vooruit:</strong>
              </p>
              <div class="form-group quick-select">
                <div class="custom-control custom-checkbox custom-control-inline">
                  <input
                      type="checkbox"
                      id="quickselect1"
                      value="All"
                      class="custom-control-input selection"
                      v-on:change="switchSelect"
                  />
                  <label class="custom-control-label" for="quickselect1">Alle</label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                  <input
                      type="checkbox"
                      id="quickselect2"
                      value="Mon"
                      class="custom-control-input selection"
                      v-on:change="switchSelect"
                  />
                  <label class="custom-control-label" for="quickselect2">Ma</label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                  <input
                      type="checkbox"
                      id="quickselect3"
                      value="Tue"
                      class="custom-control-input selection"
                      v-on:change="switchSelect"
                  />
                  <label class="custom-control-label" for="quickselect3">Di</label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                  <input
                      type="checkbox"
                      id="quickselect4"
                      value="Wed"
                      class="custom-control-input selection"
                      v-on:change="switchSelect"
                  />
                  <label class="custom-control-label" for="quickselect4">Wo</label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                  <input
                      type="checkbox"
                      id="quickselect5"
                      value="Thu"
                      class="custom-control-input selection"
                      v-on:change="switchSelect"
                  />
                  <label class="custom-control-label" for="quickselect5">Do</label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                  <input
                      type="checkbox"
                      id="quickselect6"
                      value="Fri"
                      class="custom-control-input selection"
                      v-on:change="switchSelect"
                  />
                  <label class="custom-control-label" for="quickselect6">Vr</label>
                </div>
              </div>
              <div class="syncfusion-calendar mb-4">
                <input type="text" v-model="dates" required="required" />
                <div class="icon-wrapper arrow-back">
                  <i class="material-icons-round">arrow_back</i>
                </div>
                <div class="icon-wrapper arrow-forward">
                  <i class="material-icons-round">arrow_forward</i>
                </div>
                <keep-alive>
                  <v-date-picker
                      locale="nl"
                      mode="multiple"
                      v-model="dates"
                      :first-day-of-week="week"
                      :min-date="minDate"
                      :max-date="maxDate"
                      :available-dates="availableDates"
                      :disabled-dates="disableDates"
                      ref="calendarInstance"
                      is-expanded
                      is-inline
                  ></v-date-picker>
                </keep-alive>
              </div>
            </template>
            <template v-if="step === 2 && subBranch === '2' || step === 3 && subBranch === '1' && form.duration_type === '1'">
              <register-steps :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="33"
                              currentStep="2"/>
              <div class="sd-title medium" style="margin-bottom: 20px;">
                {{ subBranch === '2' ? 'Voor welke periode zoek je een docent?' : questions[2] ? 'Voor welke periode zoekt u een invaller?' : '' }}
              </div>

              <div class="sd-form">
                <div class="input-row">
                  <div class="sd-input sd-col-6 form-group date-style">
                    <label for="startDate">Gewenste startdatum</label>
                    <keep-alive>
                      <v-date-picker
                          locale="nl"
                          mode="date"
                          v-model="startDate"
                          @input="generateDates"
                          ref="calendarInstance"
                          :min-date="new Date()"
                          :max-date="new Date(new Date().setMonth(new Date().getMonth() + 6))"
                      ></v-date-picker>
                    </keep-alive>
                  </div>

                  <div class="sd-input sd-col-6 form-group date-style">
                    <label for="endDate">Verwachte einddatum</label>
                    <keep-alive>
                      <v-date-picker
                          locale="nl"
                          mode="date"
                          v-model="endDate"
                          @input="generateDates"
                          ref="calendarInstance"
                          :min-date="new Date()"
                          :max-date="new Date(new Date().setMonth(new Date().getMonth() + 12))"
                      ></v-date-picker>
                    </keep-alive>
                  </div>
                  <span class="extra-info sd-col-12" style="margin-top: -10px;">
                    <svg-icon icon="information"/>
                    Ter info: wanneer de startdatum is verstreken, wordt deze automatisch verplaatst zodat de vacature actief blijft.
                  </span>
                </div>
                <template v-if="subBranch === '2'">
                <div class="input-row">
                  <!-- Hours per week -->
                  <div class="sd-col-12 sd-input form-group date-style">
                    <label for="hoursPerWeek">(Geschat) aantal lesuur per week</label>
                    <input
                        type="number"
                        id="hoursPerWeek"
                        v-model="form.periods"
                        min="0"
                        placeholder="Bijvoorbeeld: 16"
                        class="form-control"
                        required
                    />
                  </div>
                </div>
                </template>
              </div>

              <!-- Workdays -->
              <div class="form-group custom-days-list">
                <label><b>Werkdagen</b></label>
                <div>
                  <div v-for="(day, index) in daysOfWeek" :key="index" class="custom-control custom-checkbox custom-control-inline">
                    <input
                        type="checkbox"
                        :id="`day-${index}`"
                        :value="day"
                        v-model="selectedDays"
                        @change="generateDates"
                        class="custom-control-input"
                    />
                    <label :for="`day-${index}`" class="custom-control-label">{{ day }}</label>
                  </div>
                  <!-- "Niet bekend" option -->
                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input
                        type="checkbox"
                        id="not-known"
                        value="unknown"
                        v-model="selectedDays"
                        @change="generateDates"
                        class="custom-control-input"
                    />
                    <label class="custom-control-label" for="not-known">Dagen in overleg/nog onbekend</label>
                  </div>

                </div>
              </div>
            </template>

            <template v-if="step === 3 && subBranch === '2' || step === 4 && subBranch === '1' && form.duration_type === '0'">
              <register-steps :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="66" currentStep="2" />
              <div class="sd-title medium" style="margin-bottom: 20px;">
                <span class="steps">2/2</span>
                {{ questions[step] ? questions[step].display : '' }}
              </div>
              <div class="extra-info collapsable">
                <span class="extra-info-title" @click="showExtraInfo()" :class="this.ExtraInfo ? 'open' : ''">
                  <svg-icon icon="information" /><strong>Meer info over het invullen van tijden</strong>
                  <span class="expand"></span>
                </span>
                <span class="extra-info-content" v-if="this.ExtraInfo">
                  <template v-if="subBranch == '2'">
                    Vul per dag het aantal lesuren in voor deze vacature. Kies daarnaast de begin- en eindtijd, dit is de tijd dat de invalkracht op school aanwezig zal zijn, waarbinnen de lesuren vallen.<br />
                    Het aantal lesuren is leidend voor het aantal uur dat de invalkracht uitbetaald krijgt en wat op de factuur komt te staan. Dit wordt als volgt berekend:  [minuten per lesuur] : 60 (minuten per klokuur) x [aantal lesuur per dag] x [opslagfactor]. Wijzigen de lesuren na het invullen van de vacature? Geef het dan zo spoedig mogelijk via mail/whatsapp/telefoon aan ons door.
                  </template>
                  <template v-else>
                    Geef hier per dag aan hoe laat de invalkracht aanwezig dient te zijn en hoe laat de dag klaar is. Deze uren zijn leidend voor de uitbetaling en facturatie. Wijzigen de uren na het invullen van de vacature? Geef het dan zo spoedig mogelijk via mail/whatsapp/telefoon aan ons door.
                  </template>
                </span>
              </div>
              <div class="form">
                <div v-if="subBranch == '2'" class="input-row form-row">
                  <div class="sd-input col-6">
                    <label for="form-time-addon">Opslagfactor<span class="required">*</span></label>
                    <input
                        id="form-time-addon"
                        class="form-control"
                        v-model="form.time_add_on"
                        name="form-hour-addon"
                        placeholder="0,0"
                        required
                    />
                  </div>
                  <div class="sd-input col-6">
                    <label for="period_duration">Minuten per lesuur<span class="required">*</span></label>
                    <input
                        id="period_duration"
                        type="number"
                        class="form-control"
                        v-model="form.period_duration"
                        name="period_duration"
                        placeholder="0"
                    />
                  </div>
                </div>
                <ol id="time-selection" class="list-unstyled">
                  <li v-for="(item, key, index) in form.working_dates" v-bind:key="key">
                    <div class="grid-time-container">
                      <div class="grid-item">
                        <strong>{{ dayOfWeek(key) }}</strong>
                        {{ dateFlip(key) }}
                      </div>
                      <div class="grid-item">
                        <label class="w-100 mb-0"><strong>Begintijd</strong></label>
                        <div class="display-grid input-group mb-1 mt-0">
                          <div class="w-square-icon">
                            <select
                              v-on:change="updateTime($event, 'start', 'hour', key)"
                              class="starthour custom-select timestamp"
                            >
                              <option
                                class="time-option"
                                v-for="hour in selectable_hours"
                                v-bind:key="hour"
                                :selected="hour == item.startTime.split(':')[0]"
                              >{{ hour }}</option>
                            </select>
                            <div class="icon-wrapper dropdown position-absolute align-self-center">
                              <svg-icon icon="chevron_s"/>
                            </div>
                          </div>
                          <strong class="ml-1 mr-1 mb-0"> : </strong>
                          <div class="w-square-icon">
                            <select
                              v-on:change="updateTime($event, 'start', 'minute', key)"
                              class="startminute custom-select timestamp"
                            >
                              <option
                                class="time-option"
                                v-for="minute in selectable_minutes"
                                v-bind:key="minute"
                                :selected="minute == item.startTime.split(':')[1]"
                              >{{ minute }}</option>
                            </select>
                            <div class="icon-wrapper dropdown position-absolute align-self-center">
                              <svg-icon icon="chevron_s"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="grid-item">
                        <label class="w-100 mb-0"><strong>Eindtijd</strong></label>
                        <div class="display-grid input-group mb-1 mt-0 mr-0">
                          <div class="w-square-icon">
                            <select
                              v-on:change="updateTime($event, 'end', 'hour', key)"
                              class="endhour custom-select timestamp"
                            >
                              <option
                                class="time-option"
                                v-for="hour in selectable_hours"
                                v-bind:key="hour"
                                :selected="hour == item.endTime.split(':')[0]"
                              >{{ hour }}</option>
                            </select>
                            <div class="icon-wrapper dropdown position-absolute align-self-center">
                              <svg-icon icon="chevron_s"/>
                            </div>
                          </div>
                          <strong class="ml-1 mr-1 mb-0"> : </strong>
                          <div class="w-square-icon">
                            <select
                              v-on:change="updateTime($event, 'end', 'minute', key)"
                              class="endminute custom-select timestamp"
                            >
                              <option
                                class="time-option"
                                v-for="minute in selectable_minutes"
                                v-bind:key="minute"
                                :selected="minute == item.endTime.split(':')[1]"
                              >{{ minute }}</option>
                            </select>
                            <div class="icon-wrapper dropdown position-absolute align-self-center">
                              <svg-icon icon="chevron_s"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <template v-if="subBranch === '2'">
                        <div></div>
                        <div class="grid-item">
                          <label for="Teaching-hours"><strong>Aantal lesuren<span class="required">*</span></strong></label>
                          <input
                            id="teaching-hours"
                            type="number"
                            class="form-control"
                            name="teaching-hours"
                            placeholder="0"
                            v-model="item.periods"
                          />
                        </div>
                        <div class="grid-item clockhours">
                          <strong>Aantal klokuren</strong>
                          <span>{{ showClockHours(key) }}</span>
                        </div>
                        <div></div>
                        <div class="grid-item long">
                          <strong
                              v-on:click="setTimestampsAsDefaultForDay(key)"
                              class="text-warning mb-0"
                              role="button"
                          >Tijd gebruiken op elke {{ dayOfWeek(key).toLowerCase() }}</strong>
                        </div>
                      </template>
                      <template v-if="index == 0">
                        <div></div>
                        <div class="grid-item long">
                          <strong
                            v-on:click="setTimestampsAsDefault(key)"
                            class="text-warning mb-0"
                            role="button"
                          >Deze tijd voor alle dagen instellen</strong>
                        </div>
                      </template>
                    </div>
                  </li>
                </ol>
              </div>
            </template>

            <template v-if="branch == 1 && step === 4 && subBranch == '2'">
              <register-steps :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="20" currentStep="3" />
              <div class="sd-title medium" style="margin-bottom: 20px;">
                <span class="steps">1/4</span>
                {{ questions[step] ? questions[step].display : '' }}
              </div>
              <div class="form">
                <ul id="audience" class="list-unstyled">
                  <li v-for="item in answers[step]" v-bind:key="item.id">
                    <div class="custom-control custom-checkbox">
                      <input
                          type="checkbox"
                          class="custom-control-input"
                          v-model="audiences[item.id]"
                          :value="item.id"
                          v-bind:id="`audience-` + item.id"
                      />
                      <label
                          class="custom-control-label"
                          v-bind:for="`audience-` + item.id"
                      >{{ item.answer }}</label>
                    </div>
                  </li>
                </ul>
              </div>
            </template>

            <template v-if="branch == 1 && step === 5 && subBranch == '2'">
              <register-steps :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="20" currentStep="3" />
              <div class="sd-title medium" style="margin-bottom: 20px;">
                <span class="steps">2/4</span>
                {{ questions[step] ? questions[step].display : '' }}
              </div>
              <div class="form">
                <ul id="audience" class="list-unstyled">
                  <li v-for="item in answers[step]" v-bind:key="item.id">
                    <div class="custom-control custom-checkbox">
                      <input
                          type="checkbox"
                          class="custom-control-input"
                          v-model="groups[item.id]"
                          :value="item.id"
                          v-bind:id="`groups-` + item.id"
                      />
                      <label
                          class="custom-control-label"
                          v-bind:for="`groups-` + item.id"
                      >{{ item.answer }}</label>
                    </div>
                  </li>
                </ul>
              </div>
            </template>

            <template v-if="branch == 1 && step === 6 && subBranch == '2'">
              <register-steps :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="20" currentStep="3" />
              <div class="sd-title medium" style="margin-bottom: 20px;">
                <span class="steps">3/4</span>
                Vak en bevoegdheid
              </div>
              <div class="sd-form">
                <div class="input-row">
                  <div class="sd-input sd-col-12 form-group w-square-icon">
                    <label>{{ questions[6] ? questions[6].display : '' }}</label>
                    <select
                      class="custom-select"
                      v-model="form.subject"
                      @change="isVmboProfile"
                    >
                      <option value="" selected disabled hidden>selecteer een vak</option>
                      <option
                        class="time-option"
                        v-for="answer in answers[6]"
                        v-bind:value="answer.id"
                      >{{ answer.answer }}</option>
                    </select>
                    <div class="icon-wrapper dropdown position-absolute align-self-center">
                      <svg-icon icon="chevron_s"/>
                    </div>
                  </div>
                  <div class="sd-input sd-col-12 form-group w-square-icon">
                    <label>{{ questions[7] ? questions[7].display : '' }}</label>
                    <select
                      class="startminute custom-select"
                      v-model="form.qualification"
                    >
                      <option value="" selected disabled hidden>selecteer een graad</option>
                      <option
                        class="time-option"
                        v-for="answer in answers[7]"
                        v-bind:value="answer.id"
                        v-if="isVmboAnswer(answer)"
                      >{{ answer.answer }}</option>
                    </select>
                    <div class="icon-wrapper dropdown position-absolute align-self-center">
                      <svg-icon icon="chevron_s"/>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="branch == 1 && (step === 4 && subBranch == '1' && form.duration_type == '1') || (step === 5 && subBranch == '1' && form.duration_type == '0')">
              <register-steps :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="20" currentStep="3" />
              <div class="sd-title medium" style="margin-bottom: 20px;">
                <span class="steps">1/5</span>
                {{ questions[4] ? questions[4].display : '' }}
              </div>
              <div class="form">
                <ul id="audience" class="list-unstyled" :class="{'audience-list': audienceClass}">
                  <li v-for="item in answers[4]" v-bind:key="item.id">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        v-model="audiences[item.id]"
                        :value="item.id"
                        v-bind:id="`audience-` + item.id"
                        @click="setCheckboxes(item.id, $event)"
                      />
                      <label
                        class="custom-control-label"
                        v-bind:for="`audience-` + item.id"
                      >{{ item.answer }}</label>
                    </div>
                  </li>
                </ul>
              </div>
            </template>
            <template v-if="(branch == 1 && subBranch == '1' && step > 4 && step <= 7 && form.duration_type == '1')
            || (branch == 2 && step > 3 && step <= 5)">
              <register-steps v-if="step === 5 && branch == 1" :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="20" currentStep="3" />
              <register-steps v-if="step === 6 && branch == 1" :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="40" currentStep="3" />
              <register-steps v-if="step === 7 && branch == 1" :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="60" currentStep="3" />
              <div class="sd-title medium" style="margin-bottom: 20px;">
                <span class="steps" v-if="step === 5 && branch == 1">2/5</span>
                <span class="steps" v-if="step === 6 && branch == 1">3/5</span>
                <span class="steps" v-if="step === 7 && branch == 1">4/5</span>
                {{ questions[step] ? questions[step].display : '' }}
              </div>
              <div class="form">
                <ul class="list-unstyled">
                  <li v-for="item in answers[step]" v-bind:key="item.id">
                    <div class="custom-control custom-radio">
                      <input
                          type="radio"
                          class="custom-control-input"
                          v-model="form[choices_guide[step]]"
                          :value="item.id"
                          v-bind:id="choices_guide[step] + `-` + item.id"
                      />
                      <label
                          class="custom-control-label"
                          v-bind:for="choices_guide[step] + `-` + item.id"
                      >{{ item.answer }}</label>
                    </div>
                  </li>
                </ul>
              </div>
            </template>
            <template v-if="branch == 1 && subBranch == '1' && step > 5 && step <= 8 && form.duration_type == '0'">
              <register-steps v-if="step === 6 && branch == 1" :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="20" currentStep="3" />
              <register-steps v-if="step === 7 && branch == 1" :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="40" currentStep="3" />
              <register-steps v-if="step === 8 && branch == 1" :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="60" currentStep="3" />
              <div class="sd-title medium" style="margin-bottom: 20px;">
                <span class="steps" v-if="step === 6 && branch == 1">2/5</span>
                <span class="steps" v-if="step === 7 && branch == 1">3/5</span>
                <span class="steps" v-if="step === 8 && branch == 1">4/5</span>
                {{ questions[step-1] ? questions[step-1].display : '' }}
              </div>
              <div class="form">
                <ul class="list-unstyled">
                  <li v-for="item in answers[step-1]" v-bind:key="item.id">
                    <div class="custom-control custom-radio">
                      <input
                          type="radio"
                          class="custom-control-input"
                          v-model="form[choices_guide[step-1]]"
                          :value="item.id"
                          v-bind:id="choices_guide[step-1] + `-` + item.id"
                      />
                      <label
                          class="custom-control-label"
                          v-bind:for="choices_guide[step-1] + `-` + item.id"
                      >{{ item.answer }}</label>
                    </div>
                  </li>
                </ul>
              </div>
            </template>
          </div>
        </div>
        <template v-if="subBranch == '1' && form.duration_type == '0'">
        <div>
          <v-stepper style="display: none;" ref="stepper" :steps="8" :linear="false" v-model="step"></v-stepper>
        </div>
        </template>
        <template v-else>
        <div hidden>
          <v-stepper ref="stepper" :steps="steps" :linear="false" v-model="step"></v-stepper>
        </div>
        </template>
      </form>
    </div>
    <div class="step next-btn">
      <template v-if="subBranch == '1' && form.duration_type == '0'">
      <div class="px-4 mx-2">
        <button
            v-if="step < 8"
            type="button"
            title="Volgende"
            class="btn btn-warning btn-block"
            @click="nextStep"
        >Volgende</button>
        <!-- @click="$refs.stepper.next()" -->
        <button
            v-if="step == 8"
            type="button"
            title="Volgende"
            class="btn btn-warning btn-block"
            @click="triggerSubmit"
        >Volgende</button>
        <!-- v-on:click="done = true" -->
      </div>
      </template>
      <template v-else>
        <div class="px-4 mx-2">
          <button
              v-if="step < steps"
              type="button"
              title="Volgende"
              class="btn btn-warning btn-block"
              @click="nextStep"
          >Volgende</button>
          <!-- @click="$refs.stepper.next()" -->
          <button
              v-if="step == steps"
              type="button"
              title="Volgende"
              class="btn btn-warning btn-block"
              @click="triggerSubmit"
          >Volgende</button>
          <!-- v-on:click="done = true" -->
        </div>
      </template>
    </div>
    <div v-if="done" class="fullscreen-notif position-fixed">
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <div class="icon svg mb-4 pb-1">
              <svg
                  viewBox="0 0 122 106"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g transform="translate(3.000000, 3.000000)">
                    <g stroke="#625A55" stroke-width="4.2">
                      <path
                          d="M-1.77635684e-15,100 C-1.77635684e-15,80.1827237 21.0048161,64.1176471 46.9155699,64.1176471 C72.8263237,64.1176471 93.8311398,80.1827237 93.8311398,100 L-1.77635684e-15,100 Z"
                      />
                      <ellipse
                          cx="46.9155699"
                          cy="31.7647059"
                          rx="31.6680097"
                          ry="31.7647059"
                          fill="#FFCD00"
                      />
                      <path
                          d="M95.8086962,17.4085625 L108.95566,71.234468"
                          fill="#D8D8D8"
                          fill-rule="nonzero"
                          stroke-linecap="round"
                          transform="translate(102.382178, 44.321515) rotate(45.000000) translate(-102.382178, -44.321515) "
                      />
                      <polyline points="28.7357866 66.4705882 46.9155699 80 64.5089086 66.4705882" />
                    </g>
                    <g
                        transform="translate(38.000000, 29.000000)"
                        fill="#625A55"
                        fill-rule="nonzero"
                    >
                      <circle cx="4" cy="4" r="4" />
                      <circle cx="26" cy="4" r="4" />
                    </g>
                    <path
                        d="M42.1844298,46.3411731 C47.8510965,51.6352907 53.5177632,52.7252561 59.1844298,49.6110692"
                        stroke="#625A55"
                        stroke-width="4"
                        stroke-linecap="round"
                        transform="translate(50.684430, 48.841173) rotate(-8.000000) translate(-50.684430, -48.841173) "
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div class="sd-title large text-uppercase bold text-white text-center mb-4">Gelukt!</div>
            <div
                class="heading-20-500"
            >De vacature is geplaatst. Bekijk matches en sollicitaties via het dashboard.</div>
          </div>
        </div>

        <div class="footer-btn">
          <div class="container-fluid px-4 mx-2">
            <router-link
                :to="{ name: 'company-dashboard' }"
                title="Bekijk"
                class="btn btn-light btn-block"
                v-ripple="'rgba(192, 189, 187, 0.35)'"
            >Naar het dashboard</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {VStepper} from "vue-stepper-component";
import {id} from "vue-cli-plugin-cordova/defaults";

export default {
  components: {
    VStepper
  },
  data: function() {
    var steps;

    if(localStorage.getItem("branch") == 1 && localStorage.getItem('subBranch') == '2')
      steps = 6;
    else if(localStorage.getItem("branch") == 1)
      steps = 7;
    else if(localStorage.getItem("branch") == 2)
      steps = 5;

    return {
      branch: localStorage.getItem("branch"),
      subBranch: localStorage.getItem('subBranch'),
      isPopupVisible: false,
      popupMessage: '',
      startDate: null,
      endDate: null,
      selectedDays: [],
      daysOfWeek: [
        "Maandag",   // 1
        "Dinsdag",   // 2
        "Woensdag",  // 3
        "Donderdag", // 4
        "Vrijdag",   // 5
      ],
      steps: steps,
      step: 1,
      answered: 0,
      done: null,
      questions: {},
      questions_array: {},
      choices_guide: null,
      answers_array: {},
      answers: {},
      locationList: [],
      ExtraInfo: false,
      form: {
        working_dates: {},
        address_id: "",
        time_add_on: "",
        period_duration: "",
        pabo_allowed: "",
        periods: null,
        audience: [],
        group: [],
        group_id: "",
        dates_pending: 0,
        duration_type: "",
        education_experience_id: "",
        denomination_id: "",
        discipline_id: "",
        title: "",
        description: "",
        subject: "",
        qualification: "",
      },
      periods: {},
      audiences: [false, false, false, false, false, false, false, false, false],
      groups: [false, false, false, false, false, false, false, false, false],
      audiencesDisabled: [],
      audiencesTrueCount: 0,
      availableDates: null,
      availableDatesSelect: null,
      dates: [],
      quick: [],
      minDate: "",
      maxDate: "",
      week: 2,
      All_switch: false,
      Mon_switch: false,
      Tue_switch: false,
      Wed_switch: false,
      Thu_switch: false,
      Fri_switch: false,
      prevRoute: null,
      titles: {
        start_date: "",
        dates_text: "",
        education_text: "",
        audience_text: "",
        city_text: ""
      },
      selectable_hours: ["06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20"],
      selectable_minutes: ["00", "15", "30", "45"],
      default_start_hour: "",
      default_start_minute: "",
      default_end_hour: "",
      default_end_minute: "",
      vmboProfile: false
    };
  },
  async created() {},
  async mounted() {
    var minDate = new Date();
    minDate.setHours(0, 0, 0, 0);
    minDate.setDate(minDate.getDate());
    this.minDate = minDate;

    var maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 5);
    maxDate.setHours(0, 0, 0, 0);
    this.maxDate = maxDate;

    this.getCalendarDates();
    await this.fetchData();
  },
  watch: {
    $route: "fetchData",
    step: {
      immediate: true,
      handler() {
        this.answered = Math.floor((this.step / this.steps) * 100);
      }
    },
    //check if the variable selected days changes
    selectedDays: {
      handler() {
        this.generateDates();
      }
    },
    form: {
      immediate: true,
      handler: function() {
        this.buildTheTitle();
      },
      deep: true
    },
    dates: {
      immediate: true,
      handler: function() {
        this.quick = [];
        this.formatDates();
        this.sortDateArray();
      },
      deep: true
    },
    audiences: {
      immediate: true,
      handler: function() {
        var arr = this.audiences;
        var arr2 = [];
        arr.forEach(function(x, index) {
          if (arr[index]) {
            arr2.push(index);
          }
        });
        this.form.audience = arr2;
      },
      deep: true
    },
    groups: {
      immediate: true,
      handler: function() {
        var arr = this.groups;
        var arr2 = [];
        arr.forEach(function(x, index) {
          if (arr[index]) {
            arr2.push(index);
          }
        });
        this.form.group = arr2;
      },
      deep: true
    }
  },
  updated: function() {
    this.$nextTick(function() {
      this.buildTheTitle();
    });
  },
  methods: {
    audienceClass: function () {
      return this.subBranch == '1';
    },
    generateDates() {
      if (this.selectedDays.includes("unknown")) {
        const days = 5;
        for (let i = 0; i < days; i++) {
          document.getElementById("day-" + (i)).checked = false;
        }
      }
      if (this.startDate && this.endDate) {
        const start = new Date(this.startDate);
        const end = new Date(this.endDate);

        if (end < start) {
          alert("Einddatum kan niet vóór de startdatum zijn.");
          this.dates = [];
          return;
        }

        this.dates = [];
        let current = new Date(start.getTime());

        while (current <= end) {
          const dayIndex = current.getDay();

          if (this.selectedDays.includes("unknown")) {
            this.form.dates_pending = 1;
            if (dayIndex >= 1 && dayIndex <= 5) {
              this.dates.push(new Date(current.getTime()));
            }
          } else {
            // Regular logic: Only add selected days
            if (dayIndex >= 1 && dayIndex <= 5) {
              const dayName = this.daysOfWeek[dayIndex - 1];

              if (this.selectedDays.includes(dayName)) {
                this.dates.push(new Date(current.getTime()));
              }
            }
          }

          current.setDate(current.getDate() + 1);
        }
      }
    },

    setCheckboxes(item, event) {
      if (event.target.checked) {
        this.audiencesTrueCount += 1;
        if (this.audiencesTrueCount === 1) {
          for (let i = 1; i < 9; i++) {
            if (this.audiences[i] === false) {
              this.audiencesDisabled[i] = true;
            }
          }
        }
        if (item === 1) {
          this.audiencesDisabled[item] = false;
          this.audiencesDisabled[item + 1] = false;
        } else if (item === 8) {
          this.audiencesDisabled[item] = false;
          this.audiencesDisabled[item - 1] = false;
        } else {
          this.audiencesDisabled[item] = false;
          this.audiencesDisabled[item + 1] = false;
          this.audiencesDisabled[item - 1] = false;
        }
      } else {
        this.audiencesTrueCount -= 1;
        if (this.audiencesTrueCount === 0) {
          for (let i = 0; i < 9; i++) {
            this.audiencesDisabled[i] = false;
          }
        }
        if (this.audiences[item + 1] === true) {
          this.audiencesDisabled[item] = false;
          this.audiencesDisabled[item - 1] = true;
        }
        if (this.audiences[item - 1] === true) {
          this.audiencesDisabled[item] = false;
          this.audiencesDisabled[item + 1] = true;
        }
      }
      for (let i = 1; i < 9; i++) {
        if (this.audiencesDisabled[i] === true) {
          document.getElementById("audience-" + i).disabled = true;
        } else {
          document.getElementById("audience-" + i).disabled = false;
        }
      }
    },
    quickSelectDates(day, addit) {
      this.quick = [];
      for (var i in this.availableDatesSelect) {
        let val = this.availableDatesSelect[i].toString();
        let el_day = val.slice(0, 3);
        if (el_day == day && this.availableDatesSelect[i].getTime() > (new Date().getTime() - (24*60*60*1000))) {
          this.quick.push(this.availableDatesSelect[i]);
        }
      }
      var _ctr;
      var _quickDates = [];
      var _oldDates = [];
      var _newDates = [];
      for (_ctr = 0; _ctr < this.quick.length; _ctr++) {
        let _date = String(this.quick[_ctr]);
        _quickDates.push(_date);
      }
      for (_ctr = 0; _ctr < this.dates.length; _ctr++) {
        let _date = String(this.dates[_ctr]);
        _oldDates.push(_date);
      }

      if (addit) {
        _quickDates.forEach(function(val) {
          if (!_oldDates.includes(val)) {
            _newDates.push(new Date(val));
          }
        });
      } else {
        _oldDates.forEach(function(val) {
          if (!_quickDates.includes(val)) {
            _newDates.push(new Date(val));
          }
        });
        this.dates = [];
      }
      this.dates = this.dates.concat(_newDates);
    },
    getCalendarDates() {
      if (this.minDate && !this.availableDates) {
        this.availableDates = this.getDateArray(
          new Date(this.minDate),
          new Date(this.maxDate)
        );
      }
    },
    showExtraInfo() {
      this.ExtraInfo = !this.ExtraInfo;
    },
    async fetchData() {
      this.$store.state.loading = true;
      this.setDefaultTimes()
      this.setChoicesGuide();
      await this.getQuestions();
      await this.getAnswers();
      await this.getLocationsList();
      // await this.fillForm();
      // await this.getUserAnswers();

      await this.autoFillForm();
      this.$forceUpdate();
      this.$store.state.loading = false;
    },
    async autoFillForm() {
      return new Promise(resolve => {
        if (localStorage.getItem("job")) {
          const job = JSON.parse(localStorage.getItem("job"));
          job.duration_type = String(job.duration_type);
          for (var obj in job) {
            if (obj == "id") {
              this.form[obj] = job[obj]; // ID
            } else {
              if (this.form.hasOwnProperty(obj)) {
                this.form[obj] = job[obj]; // update
              }
              if(this.subBranch == '1') {
                if (obj == "audience") {
                  var _audiences = job[obj];
                  if (!Array.isArray(_audiences)) {
                    _audiences = JSON.parse(job[obj]);
                  }
                  for (var _key in _audiences) {
                    this.audiences[_audiences[_key]] = true;
                  }
                  this.form[obj] = _audiences;
                }
              }

              if(this.subBranch == '2') {
                if(obj == "audience_ids") {
                  var _audiencesId = job[obj];
                  if (!Array.isArray(_audiencesId)) {
                    _audiencesId = JSON.parse(job[obj]);
                  }
                  for (var _key in _audiencesId) {
                    this.audiences[_audiencesId[_key]] = true;
                  }
                  this.form["audience"] = _audiencesId;
                }

                if(obj == "group_ids") {
                  var _groupId = job[obj];
                  if (!Array.isArray(_groupId)) {
                    _groupId = JSON.parse(job[obj]);
                  }
                  for (var _key in _groupId) {
                    this.groups[_groupId[_key]] = true;
                  }
                  this.form["group"] = _groupId;
                }

                if(obj == "subject_id") {
                  var _subjectId = job[obj];

                  this.form["subject"] = _subjectId;
                }

                if(obj == "qualification_id") {
                  var _qualificationId = job[obj];

                  this.form["qualification"] = _qualificationId;
                }

                if(obj == "time_add_on") {
                  var _addon = Number(job[obj]).toFixed(2);
                  this.form["time_add_on"] = _addon.replace('.', ',');
                }
              }
            }
          }
          if (this.form.working_dates) {
            let working_dates = JSON.parse(JSON.parse(this.form.working_dates));
            for (var key in working_dates) {
              key = key.split('-');
              let _y = parseInt(key[0]);
              let _m = parseInt(key[1]) - 1;
              let _d = parseInt(key[2]);

              key = new Date(_y, _m, _d, 0, 0, 0);
              this.dates.push(key);
            }
          }
          localStorage.setItem("form-pending", JSON.stringify(true));

          if (
            (this.dates && this.dates.length > 0 && this.subBranch == '2') ||
            (this.subBranch == '1' &&
              this.form.duration_type == '1' &&
              this.dates &&
              this.dates.length > 0)
          ) {
            const sortedDates = [...this.dates].sort((a, b) => a - b);

            const firstDate = new Date(sortedDates[0]);
            this.startDate = firstDate

            const lastDate = new Date(sortedDates[sortedDates.length - 1]);
            this.endDate = lastDate
            const uniqueDays = [...new Set(sortedDates.map(date => {
              const day = new Date(date).getDay();
              return this.daysOfWeek[day - 1];
            }))];

            this.selectedDays = uniqueDays;
            this.generateDates();
          }
        }

        resolve();
      });
    },
    async getLocationsList() {
      let promises = [];
      promises.push(
        new Promise(resolve => {
          let user = JSON.parse(localStorage.getItem("user"));
          this.locationList = user.addresses;
          this.form.time_add_on = (user && user.time_add_on) ? user.time_add_on : '';
          this.form.period_duration = (user && user.period_duration) ? user.period_duration : '';
          resolve();
        })
      );
      return Promise.all(promises);
    },
    // get questions
    async getQuestions() {
      let promises = [];
      var q_url = this.$apiURI + "/question/job/" + this.branch + "/";
      var q_ctr = 1;
      var subbranch = "";
      var arr = this.choices_guide;
      var steps = this.branch == 1 && this.subBranch == '2' ? 7 : this.steps;

      if(this.subBranch) {
        subbranch = "/" + this.subBranch;
      }

      //assign questions
      while (q_ctr <= steps) {
        promises.push(
          new Promise(resolve => {
            this.$http({
              method: "GET",
              url: q_url + q_ctr + subbranch
            }).then(
              result => {
                var q_id = result.data.data[0].id;
                var q_number = result.data.data[0].number;
                var t_obj = {
                  id: q_id,
                  display: result.data.data[0].display
                };

                var target = arr[q_number];
                if(q_number > 2 && q_number <= 8 && this.subBranch == '2') {
                  this.$set(t_obj, "target", target);
                }else if (q_number > 2 && q_number < 7 ) {
                  this.$set(t_obj, "target", target);
                }

                this.$set(this.questions, q_number, t_obj);
                this.$set(this.questions_array, q_number, q_id);

                resolve();
              },
              error => {
                console.error(error);
              }
            );
            q_ctr++;
          })
        );
      }
      return Promise.all(promises);
    },
    //assign answers
    async getAnswers() {
      let promises = [];
      var a_url = this.$apiURI + "/answers/" + this.branch + "/";
      var arr = {};
      var subbranch = '';

      if(this.branch == 1 && this.subBranch == "2") {
          arr = {
            group: 4,
            audience: 5,
            subject: 6,
            qualification: 7,
          }
      } else if (this.branch == 1 && this.subBranch == "1") {
        arr = {
          audience: 4,
          group: 5,
          education_experience: 6,
          denomination: 7
        };
      } else if (this.branch == 2) {
        arr = {
          childcare_workfield: 4,
          group_childcare: 5
        };
      }

      if(this.subBranch) {
        subbranch = "/" + this.subBranch;
      }

      Object.keys(arr).forEach(itemKey => {
        promises.push(
          new Promise(resolve => {
            this.$http({
              method: "GET",
              url: a_url + itemKey + subbranch
            }).then(
              result => {
                var answerIds = {};
                var v = {};
                var array = result.data.data;
                if (itemKey == "audience" && this.subBranch === "1") {
                  var ctr = 0;
                  const last = 8;

                  var x = [];
                  while (ctr <= last) {
                    x.push({ answer: ctr, id: ctr });
                    ctr++;
                  }
                  this.$set(this.answers, arr[itemKey], x);
                  answerIds = {};
                  for (v in x) {
                    answerIds[v] = false;
                  }
                  this.$set(this.answers_array, arr[itemKey], answerIds);
                } else {
                  array = result.data.data;
                  if (itemKey == 'childcare_workfield') {
                    let newArray = { // changing the order of the elements
                      0: array[0],
                      1: array[2],
                      2: array[1]
                    };
                    array = newArray;
                  }
                  if (itemKey == 'qualification' && this.subBranch == "2") {
                    array = [ // changing the order of the elements
                      array[1],
                      array[0],
                      array[2],
                      array[3],
                      array[4],
                      array[5],
                    ];
                  }
                  this.$set(
                    this.answers,
                    arr[itemKey], //qnumber
                    array
                  );

                  answerIds = {};
                  for (v in result.data.data) {
                    answerIds[result.data.data[v].id] = false;
                  }
                  this.$set(this.answers_array, arr[itemKey], answerIds);
                }
                resolve();
              },
              error => {
                console.error(error);
              }
            );
          })
        );
      });
      return Promise.all(promises);
    },
    setChoicesGuide() {
      if (localStorage.getItem("branch") == 1 && localStorage.getItem("subBranch") == '1') {
        this.$set(this.choices_guide = [
            false,
            false,
            false,
            false,
            "audience_id",
            "group_id",
            "education_experience_id",
            "denomination_id"
        ])
      } else if(localStorage.getItem("branch") == 1 && localStorage.getItem("subBranch") == '2') {
        this.$set(this.choices_guide = [
          false,
          false,
          false,
          false,
          "audience_id",
          "group_id",
          "subject",
          "qualification",
          "academic_year"
        ])
      }
      else {
        this.$set(this.choices_guide = [
            false,
            false,
            false,
            false,
            "discipline_id",
            "group_id"
        ])
      }
    },
    setDefaultTimes() {
      if (this.branch == 1)
      {
        this.default_start_hour = "08";
        this.default_start_minute = "00";
        this.default_end_hour = "16";
        this.default_end_minute = "00";
        this.default_periods = "8"
      }
      else
      {
        this.default_start_hour = "07";
        this.default_start_minute = "30";
        this.default_end_hour = "16";
        this.default_end_minute = "30";
        this.default_periods = "8"
      }
    },
    sortedArray(array) {
      return array.sort((a, b) => 1 * a.answer.localeCompare(b.answer));
    },
    async fillForm() {
      return new Promise(resolve => {
        Object.keys(this.questions_array).forEach(questionNumber => {
          var question_id = this.questions_array[questionNumber];
          if (questionNumber == 1) {
            this.$set(this.form.user_answers, question_id, {
              answer: ""
            });
          } else {
            this.$set(this.form.user_answers, question_id, {
              answer_id: this.answers_array[questionNumber]
            });
          }
        });
        resolve();
      });
    },
    async getUserAnswers() {
      return new Promise((resolve, reject) => {
        var url = "applicant/answers/raw/experience";
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
            .get(this.$apiURI + "/" + url, {
              headers: {
                Authorization: "Bearer " + user_token,
                Accept: "application/json"
              }
            })
            .then(resp => {
              if (resp.data.data) {
                this.raw = resp.data.data;
                for (var obj in this.raw) {
                  if (this.raw[obj].question_id === 1) {
                    this.form.user_answers[this.raw[obj].question_id]["answer"] = this.raw[obj].answer;
                  } else if (this.raw[obj].question_id === 2) {
                    this.form.user_answers[this.raw[obj].question_id]["answer"] = this.raw[obj].answer;
                  } else {
                    this.form.user_answers[this.raw[obj].question_id]["answer_id"][this.raw[obj].answer_id] = true;
                  }
                }
              } else {
                return resolve(null);
              }
            })
            .catch(() => {
              const notification = {
                type: "danger",
                message: "Er is een fout opgetreden.",
                  error: true
              };
              this.$store.dispatch("notification/replace", notification, {
                root: true
              });
              return reject(null);
            });
      });
    },
    async updateUser() {
      return new Promise(resolve => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/legitimize";
        let formData = new FormData();
        for (var obj in this.form) {
          formData.append(obj, this.form[obj]);
        }
        this.$http
            .post(url, formData, {
              headers: {
                Authorization: "Bearer " + user_token,
                Accept: "application/json"
              }
            })
            .then(() => {
              localStorage.removeItem("form-pending");
              const notification = {
                type: "success",
                message: "Je hebt je gegevens succesvol aangepast. "
              };
              this.$store.dispatch("notification/replace", notification, {
                root: true
              });
              resolve();
            })
            .catch(() => {
              const notification = {
                type: "danger",
                message: "Er is een fout opgetreden.",
                  error: true
              };
              this.$store.dispatch("notification/replace", notification, {
                root: true
              });
              this.$store.state.loading = false;
            });
      });
    },
    triggerSubmit() {
      var elem = this.$refs.submit;
      elem.click();
    },
    async onSubmit() {
      var next = this.validateForm();
      if (next) {
        // continue
        // await this.saveJob();
        // this.$store.state.loading = true;
        if (this.subBranch == '2') {
          this.form.duration_type = "1";
        }
        localStorage.setItem("job", JSON.stringify(this.form));
        localStorage.removeItem("form-pending");
        // this.$store.state.loading = false;
        this.$router.replace({ name: "job_step-2" });
      }
    },
    async saveJob() { //This function is probably not used. saveJob in Step-2 in used instead
      return new Promise(resolve => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/job";

        this.formatDates();

        let formData = new FormData();
        for (var obj in this.form) {
          if (obj == "working_dates") {
            var _working_dates = this.form[obj];
            for (var i = 0; i < Object.keys(_working_dates).length; i++) {
              formData.append("working_dates[]", _working_dates[i]);
            }
          } else if(obj == "time_add_on") {
            formData.append(obj, this.form[obj].replace(',','.'));
          }
          else {
            formData.append(obj, this.form[obj]);
          }
        }
        this.$http
            .post(url, formData, {
              headers: {
                Authorization: "Bearer " + user_token,
                Accept: "application/json"
              }
            })
            .then(() => {
              console.log("success");
              this.updateLocalUser()
              this.done = true;
              resolve();
            })
            .catch(() => {
              // console.log(error.response.data);
            });
      });
    },
    buildTheTitle() {
      if (this.branch == 1 && this.step == 7) {
        if (this.form.education_experience_id) {
          this.titles.education_text = $('label[for="education_experience_id-' + this.form.education_experience_id + '"]').text();
        }
      }
      if ((this.branch == 1 && this.step == 7 && this.subBranch == '1') || (this.branch == 1 && this.step == 6 && this.subBranch == '2') || (this.branch == 2 && this.step == 5)) {
        if (Object.keys(this.form.working_dates).length) {
          this.titles.start_date = this.formatDDMMYYYY(this.form.working_dates[0]);
          this.titles.dates_text = Object.keys(this.form.working_dates).length > 1 ? "meerdere dagen" : "één dag";
        }
        if (this.form.audience && this.subBranch == '1') {
          this.titles.audience_text = this.form.audience.join(",");
        }else if(this.form.audience && this.subBranch == '2') {
          let subject = null;
          let grade = null;

          Object.keys(this.answers[6]).forEach(key => {
            if(this.answers[6][key].id === this.form.subject) {
              subject = this.answers[6][key].answer;
            }
          });

          Object.keys(this.answers[7]).forEach(key => {
            if(this.answers[7][key].id === this.form.qualification) {
              grade = this.answers[7][key].answer;
            }
          });

          this.titles.audience_text = subject + " " + grade;
        }

        if (this.form.address_id) {
          for (var addr in this.locationList) {
            if (this.locationList.hasOwnProperty(addr)) {
              if (this.form.address_id == this.locationList[addr].id) {
                this.titles.city_text = this.locationList[addr].city;
                this.titles.location_name = this.locationList[addr].name_location;
              }
            }
          }
        }

        if ((this.branch == 1 && this.step == 7 && this.subBranch == '1') ) {
          this.form.title = this.titles.city_text + ", " + this.titles.education_text + " groep " + this.titles.audience_text;
        }else if (this.branch == 1 && this.step == 6 && this.subBranch == '2') {
          this.form.title = this.titles.city_text + ", " + this.titles.education_text + " vak " + this.titles.audience_text;
        }
        else if (this.branch == 2 && this.step == 5) {
          let companyUser = JSON.parse(localStorage.getItem("user"));
          this.form.title = this.titles.location_name + " (" + companyUser.name + ")";
        }
      }
    },
    getDateArray(start, end) {
      var arr = [];
      var dt = new Date(start);
      while (dt <= end) {
        var day = dt.getDay();
        var isWeekend = day === 6 || day === 0; // 6 = Saturday, 0 = Sunday
        if (isWeekend) {
          // skip
        } else {
          arr.push(new Date(dt));
        }
        dt.setDate(dt.getDate() + 1);
      }
      return arr;
    },
    onFormChange() {
      // localStorage.setItem("form-pending", JSON.stringify(true));
      // console.log("form changed");
    },
    async switchSelect(el) {
      var _val = el.target.value;
      let targetSwitch = _val + "_switch";
      this[targetSwitch] = el.target.checked;

      if (!this[targetSwitch]) {
        if (_val == "All") {
          this.dates = [];
          document.getElementById("quickselect2").checked = this.Mon_switch = false;
          document.getElementById("quickselect3").checked = this.Tue_switch = false;
          document.getElementById("quickselect4").checked = this.Wed_switch = false;
          document.getElementById("quickselect5").checked = this.Thu_switch = false;
          document.getElementById("quickselect6").checked = this.Fri_switch = false;
        } else {
          this.quickSelectDates(_val, false);
        }
      } else {
        if (_val == "All") {
          document.getElementById("quickselect2").checked = this.Mon_switch = true;
          document.getElementById("quickselect3").checked = this.Tue_switch = true;
          document.getElementById("quickselect4").checked = this.Wed_switch = true;
          document.getElementById("quickselect5").checked = this.Thu_switch = true;
          document.getElementById("quickselect6").checked = this.Fri_switch = true;

          if (!this.availableDatesSelect) {
            if (this.minDate && !this.availableDatesSelect) {
              this.availableDatesSelect = this.getDateArray(
                  new Date(this.minDate),
                  new Date(this.minDate.getFullYear(), this.minDate.getMonth(), this.minDate.getDate() + 60)
              );
            }
          }
          this.dates = this.availableDatesSelect;
        } else {
          if (!this.availableDatesSelect) {
            if (this.minDate && !this.availableDatesSelect) {
              this.availableDatesSelect = this.getDateArray(
                  new Date(this.minDate),
                  new Date(this.minDate.getFullYear(), this.minDate.getMonth(), this.minDate.getDate() + 60)
              );
            }
          }
          this.quickSelectDates(_val, true);
        }
      }
    },
    nextStep() {
      var next = this.validateForm();
      window.scrollTo(0, 0);
      if (next) {
        if (this.step === 2 && this.subBranch === '2') {
          this.$refs.stepper.offset(2);
        } else if (this.step === 1 && this.subBranch === '1' && this.form.duration_type !== "") {
          this.$refs.stepper.offset(2);
        } else {
          this.$refs.stepper.next();
        }
      }
    },
    validateForm() {
      let $checkradios = $('input[type="radio"]:visible');
      let $input = $('input[required="required"]:visible');
      let $checkboxes = $('input:not(.selection)[type="checkbox"]:visible');
      let $timestamps = $('.timestamp');

      if ($checkradios.length) {
        let checkedRadios = $('input[type="radio"]:visible:checked').length;
        if (!checkedRadios) {
          alert("Graag een antwoord selecteren.");
          return false;
        }
      }
      if ($input.length) {
        // check if all input has values
        let emptyInputs = $('input[required="required"]:invalid').length;
        if (emptyInputs) {
          alert("Graag het formulier volledig invullen.");
          return false;
        }
      }
      if ($checkboxes.length) {
        let checkedCheckboxes = $('input[type="checkbox"]:visible:checked').length;
        if (!checkedCheckboxes) {
          alert("Graag een antwoord selecteren.");
          return false;
        }
      }

      if (this.form.periods !== null && this.form.periods !== undefined) {
        if (this.form.periods === '') {
          alert("Graag het aantal uren per week invullen.");
          return false;
        }
        const hours = Number(this.form.periods);
        if (isNaN(hours)) {
          alert("Het aantal uren per week moet een geldig getal zijn.");
          return false;
        }
        if (hours <= 0) {
          alert("Het aantal uren per week moet groter zijn dan 0.");
          return false;
        } else if (hours > 24) {
          alert("Het aantal uren per week mag niet groter zijn dan 24.");
          return false;
        }
      }

      // Validation for step 2 and subBranch '2'
      if (this.step === 2 && this.subBranch === '2' || this.step === 3 && this.subBranch === '1' && this.form.duration_type === '1') {
        // Validate startDate
        if (!this.startDate) {
          alert("Graag een startdatum selecteren.");
          return false;
        }

        if (this.form.duration_type === '1' && this.subBranch === '1') {
          if (Math.round((this.endDate - this.startDate) / (7 * 24 * 60 * 60 * 1000)) < 8) {
            alert("De einddatum moet minimaal 8 weken na de startdatum liggen.");
            return false;
          }
        }

        if (this.form.periods === null && this.subBranch === '1') {
          this.form.periods = 8 * this.selectedDays.length;
        }

        // Validate endDate
        if (!this.endDate) {
          alert("Graag een einddatum selecteren.");
          return false;
        }

        // Validate that endDate is after startDate
        if (new Date(this.endDate) <= new Date(this.startDate)) {
          alert("De einddatum moet na de startdatum liggen.");
          return false;
        }

        // Validate selectedDays
        if (this.selectedDays.length === 0) {
          alert("Graag minimaal één werkdag selecteren.");
          return false;
        }

        // Validate that there are days added between start and end date
        if (this.dates.length === 0) {
          alert("De periode tussen de start- en einddatum bevat geen geselecteerde werkdagen.");
          return false;
        }
      }

      if (this.form.duration_type === '0' && this.subBranch === '1') {
        const startDate = new Date(this.dates[0]);
        const endDate = new Date(this.dates[this.dates.length - 1]);
        if (Math.round((endDate- startDate) / (7 * 24 * 60 * 60 * 1000)) > 8) {
          alert("De einddatum mag niet meer dan 8 weken na de startdatum liggen.");
          return false;
        }
      }

      if ($timestamps.length) {
        let startHours = [];
        $('.starthour').each(function(index, val){
          startHours.push(val.value);
        });

        let startMinutes = [];
        $('.startminute').each(function(index, val){
          let minutesAsDecimal = "00";
          if (val.value === "15")
            minutesAsDecimal = "25";
          else if (val.value === "30")
            minutesAsDecimal = "50";
          else if (val.value === "45")
            minutesAsDecimal = "75";
          startMinutes.push(minutesAsDecimal);
        });

        let endHours = [];
        $('.endhour').each(function(index, val){
          endHours.push(val.value);
        });

        let endMinutes = [];
        $('.endminute').each(function(index, val){
          let minutesAsDecimal = "00";
          if (val.value === "15")
            minutesAsDecimal = "25";
          else if (val.value === "30")
            minutesAsDecimal = "50";
          else if (val.value === "45")
            minutesAsDecimal = "75";
          endMinutes.push(minutesAsDecimal);
        });

        let startTimes = [];
        for (let i = 0; i < startHours.length; i++) {
          startTimes[i] = startHours[i] + "" + startMinutes[i];
        }

        let endTimes = [];
        for (let i = 0; i < endHours.length; i++) {
          endTimes[i] = endHours[i] + "" + endMinutes[i];
        }

        for (let i = 0; i < startTimes.length; i++) {
          if (startTimes[i] >= endTimes[i]) {
            alert("Begintijden kunnen niet na de eindtijden zijn");
            return false;
          }
          else if (endTimes[i] - startTimes[i] < 300) {
            alert("Een dag kan niet korter zijn dan 3 uur");
            return false;
          }
        }
      }
      return true;
    },
    // for the calendar
    async formatDates() {
      return new Promise(resolve => {
        let originalDates = {};
        if (Object.keys(this.form.working_dates).length > 0) {
          try {
            originalDates = JSON.parse(JSON.parse(this.form.working_dates));
          } catch (e) {
            originalDates = this.form.working_dates;
          }
        }
        let newWorkingDates = {};
        for (var key in this.dates) {
          let date = this.formatDate(this.dates[key]);
          if (originalDates[date]) {
            newWorkingDates[date] = {
              startTime: originalDates[date].startTime,
              endTime: originalDates[date].endTime,
            };

            if(this.subBranch === '2') {
              newWorkingDates[date].periods = originalDates[date].periods;
            }
          } else {
            newWorkingDates[date] = {
              startTime: this.default_start_hour + ":" + this.default_start_minute,
              endTime: this.default_end_hour + ":" + this.default_end_minute,
            };

            if(this.subBranch === '2') {
              newWorkingDates[date].periods = this.default_periods;
            }
          }
        }
        this.form.working_dates = newWorkingDates;
        resolve();
      });
    },
    disableDates: function(args) {
      if (args.weekday == 2 || args.weekday == 3 || args.id == this.formatDate(new Date().getTime())) {
        args.isDisabled = true;
      }
      return args;
    },
    sortDateArray() {
      // const Moment = require("moment");
      // const array = this.form.working_dates;
      // const sortedArray = array.sort((a, b) => new Moment(a).format("YYYYMMDD") - new Moment(b).format("YYYYMMDD"));
      // if (this.form.working_dates) {
      //   this.form.working_dates = sortedArray;
      // }
      let workingDates = this.form.working_dates;
      let orderedDates = Object.keys(workingDates).sort().reduce(
        (obj, key) => {
          obj[key] = workingDates[key];
          return obj;
        },
        {}
      );
      this.form.working_dates = orderedDates;
    },
    updateTime(event, startOrEnd, hourOrMinute, selectedDate) {
      for (let i = 0; i < Object.keys(this.form.working_dates).length; i++)
      {
        if (Object.keys(this.form.working_dates)[i] == selectedDate)
        {
          let key = Object.keys(this.form.working_dates)[i];
          let oldStartTime = this.form.working_dates[key].startTime;
          let oldEndTime = this.form.working_dates[key].endTime;

          if (startOrEnd === "start" && hourOrMinute === "hour")
          {
            let oldTimeArray = oldStartTime.split(":");
            oldTimeArray[0] = event.target.value;
            this.form.working_dates[key].startTime = oldTimeArray.join(":");
          }
          else if (startOrEnd === "start" && hourOrMinute === "minute")
          {
            let oldTimeArray = oldStartTime.split(":");
            oldTimeArray[1] = event.target.value;
            this.form.working_dates[key].startTime = oldTimeArray.join(":");
          }
          else if (startOrEnd === "end" && hourOrMinute === "hour")
          {
            let oldTimeArray = oldEndTime.split(":");
            oldTimeArray[0] = event.target.value;
            this.form.working_dates[key].endTime = oldTimeArray.join(":");
          }
          else if (startOrEnd === "end" && hourOrMinute === "minute")
          {
            let oldTimeArray = oldEndTime.split(":");
            oldTimeArray[1] = event.target.value;
            this.form.working_dates[key].endTime = oldTimeArray.join(":");
          }
          break;
        }
      }
    },
    showClockHours(key) {
      var calculateValues = {
          'periods': parseInt(this.form.working_dates[key].periods),
          'period_duration': parseInt(this.form.period_duration),
          'added_time': parseFloat(this.form.time_add_on.replace(',', '.')),
        },
        calculated = (calculateValues.periods * calculateValues.period_duration * calculateValues.added_time) / 60;

      if(isNaN(calculated))
        calculated = '-';
      else
        calculated = calculated.toFixed(2).toString().replace('.', ',');

      return calculated;
    },
    setTimestampsAsDefault(key) {
      let selectedTime = this.form.working_dates[key];
      let selectedStartTime = selectedTime['startTime'];
      let selectedEndTime = selectedTime['endTime'];
      let selectedPeriod = selectedTime['periods'];

      this.default_start_hour = selectedStartTime.split(":")[0];
      this.default_start_minute = selectedStartTime.split(":")[1];
      this.default_end_hour = selectedEndTime.split(":")[0];
      this.default_end_minute = selectedEndTime.split(":")[1];
      this.default_periods = selectedPeriod;

      for (let i = 0; i < Object.keys(this.form.working_dates).length; i++) {
        let key = Object.keys(this.form.working_dates)[i];
        this.form.working_dates[key]['startTime'] = selectedStartTime;
        this.form.working_dates[key]['endTime'] = selectedEndTime;
        this.form.working_dates[key]['periods'] = selectedPeriod;
      }

      this.showPopup("De tijd is ingesteld voor alle dagen");
    },
    setTimestampsAsDefaultForDay(key) {
      let selectedTime = this.form.working_dates[key];
      let selectedStartTime = selectedTime['startTime'];
      let selectedEndTime = selectedTime['endTime'];
      let selectedPeriod = selectedTime['periods'];

      this.default_start_hour = selectedStartTime.split(":")[0];
      this.default_start_minute = selectedStartTime.split(":")[1];
      this.default_end_hour = selectedEndTime.split(":")[0];
      this.default_end_minute = selectedEndTime.split(":")[1];
      this.default_periods = selectedPeriod;


      for (let i = 0; i < Object.keys(this.form.working_dates).length; i++) {
        if(this.dayOfWeek(key) === this.dayOfWeek(Object.keys(this.form.working_dates)[i])) {
          let dateKey = Object.keys(this.form.working_dates)[i];
          this.form.working_dates[dateKey]['startTime'] = selectedStartTime;
          this.form.working_dates[dateKey]['endTime'] = selectedEndTime;
          this.form.working_dates[dateKey]['periods'] = selectedPeriod;
        }
      }

      this.showPopup("De tijd is ingesteld voor elke " + this.dayOfWeek(key).toLowerCase())
    },
    showPopup(message) {
      this.popupMessage = message;
      this.isPopupVisible = true;

      setTimeout(() => {
        this.isPopupVisible = false;
      }, 3000);
    },
    dateFlip(date) {
      return date.split("-").reverse().join("-");
    },
    dayOfWeek(date) {
      const weekdays = ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"];
      let dayAsNumber = new Date(date).getDay();
      return weekdays[dayAsNumber];
    },
    isVmboProfile(answer) {
      let isVmboProfile = false;

      Object.keys(this.answers[6]).forEach(key => {
        if(this.answers[6][key].id === this.form.subject && this.answers[6][key].sub_category === "Vmbo-profiel") {
          isVmboProfile = true;
        }
      });

      this.vmboProfile = isVmboProfile;
    },
    isVmboAnswer(answer) {
      if(this.vmboProfile === false){
        switch(answer.answer) {
          case "2e graads":
          case "1e graads":
            return true;
          default:
            return false;
        }
      }

      else if(this.vmboProfile === true) {
        switch(answer.answer) {
          case "2e graads":
          case "Pabo diploma":
          case "Geen voorkeur":
            return true
          default:
            return false;
        }
      }
    },
  },
  ready() {
    this.$forceUpdate();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    // remove the form-pending if accessing sub page
    var subpages = ["job_step-2"];
    if (subpages.indexOf(to.name) > -1) {
      next();
    } else {
      this.savePending(to, from, next);
    }
  }
};
</script>

<style scoped>
form.showing-calendar {
  margin-bottom: 320px;
}
.form-group.w-square-icon input.calendar {
  padding-right: 0;
}
.form-group.w-square-icon .calendar i[class*="material-icon"] {
  border: none;
}

.extra-info.collapsable {
  margin-bottom: 20px;
  background-color: #fff9e2;
  border-radius: 5px;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
  user-select: none;
}

.extra-info.collapsable .extra-info-title {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  width: 100%;
}

.extra-info.collapsable .extra-info-title .expand {
  position: absolute;
  right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.extra-info.collapsable .extra-info-title .expand::before,
.extra-info.collapsable .extra-info-title .expand::after {
  content: '';
  position: absolute;
  display: block;
  width: 2px;
  height: 10px;
  background-color: #64513D;
  transform: rotateZ(90deg);
  transition: .3s ease-in-out;
}

.extra-info.collapsable .extra-info-title:not(.open) .expand::after {
  transform: rotateZ(0deg);
}

.fullscreen-notif .icon.svg svg {
  right: -22px;
}
.syncfusion-calendar > input {
  position: absolute;
  opacity: 0;
}

.quick-select .custom-checkbox .custom-control-label::before {
  display: none;
}
.quick-select .custom-checkbox .custom-control-label::after {
  display: none;
}

.step-question .custom-days-list .custom-checkbox .custom-control-label {
  padding-left: 16px;
}

.step-question .custom-days-list .custom-checkbox .custom-control-label::before,
.step-question .custom-days-list .custom-checkbox .custom-control-label::after {
  display: none;
}

.step-question .custom-days-list .custom-control-input:checked ~ .custom-control-label {
  background-color: #FFCD00;
  border-color: #FFCD00;
}

.step-question .date-style {
  display: flex;
  flex-direction: column;
}

.step-question .date-style input {
  background-color: #FFF;
  border: 1px solid #64513D;
  border-radius: 10px;
}

/deep/.step-question .date-style input.vc-appearance-none.vc-text-base.vc-text-gray-800.vc-bg-white.vc-border.vc-border-gray-400.vc-rounded.vc-w-full.vc-py-2.vc-px-3 {
  height: 50px;
  background-color: #FFF;
  border: 1px solid #64513D;
  border-radius: 10px;
  color: #64513D;
  font: 14px / 50px "Real Head Pro", sans-serif;
  font-weight: 200;
}

.quick-select .custom-control {
  padding-left: 0;
  margin-right: 15px;
  cursor: pointer;
}

.step-question .custom-control {
  margin-bottom: 15px;
}

.step-question .quick-select .custom-control label {
  background-color: #FFF;
  border: 2px solid #F6F6F6;
  border-radius: 5px;
  padding: 7px 15px;
  color: #64513D;
  font-weight: 200;
  margin-bottom: 15px;
  font-size: 14px;
  line-height: 1;
}

.step-question .quick-select .custom-control input:checked + label {
  border: 2px solid #FFCD00;
  background-color: #FFCD00;
  color: #FFF;
}

.step-question .quick-select .custom-control {
  background: none;
  font-size: 16px;
  margin-bottom: 0;
}

ul.audience-list li:first-child {
  display: none;
}

.step-question .list-unstyled {
  margin: 20px 0 0;
}

.step-question ol li {
  padding: 20px;
}

.step-question ol li:nth-child(odd) {
  background-color: #f6f6f6;
  border-radius: 10px;
}

.step-question ol li strong {
  margin-bottom: 5px;
  display: block;
}

.input-group .custom-select,
.grid-item .form-control {
  border-radius: 10px !important;
  height: 35px;
  padding: 0 10px;
}

.grid-item label {
  margin-bottom: 0;
}

.display-grid {
  display: grid;
  grid-template-columns: 1fr 20px 1fr;
}

.display-grid strong {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.w-square-icon {
  position: relative;
}

.input-group .w-square-icon .icon-wrapper {
  width: 30px;
  height: 35px;
  pointer-events: none;
}

.input-group/deep/ .w-square-icon .icon-wrapper svg {
  width: 10px;
}

.grid-time-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 30px;
  row-gap: 10px;
}

.grid-time-container .grid-item.long {
  grid-column: span 2;
}

.grid-time-container .grid-item.clockhours span {
  display: block;
  margin-top: 12px;
}

.container-fluid.popup-container {
  position: fixed;
  top: 40px;
  z-index: 101;
  padding-left: 0;
  padding-right: 60px;
  animation: slide .5s forwards, slide-back .5s forwards 2.5s;
}

.container-fluid.popup-container .popup {
  width: 100%;
  border: 1px solid #44B24C;
  background-color: #bafbe6;
  color: #64513D;
  font-weight: 500;
  border-radius: 15px;
  padding: 10px 30px;
}

@keyframes slide {
  0% {
    transform: translateY(40%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}

@keyframes slide-back {
  0% {
    transform: translateY(0%);
    opacity: 1;
  }
  100% {
    transform: translateY(40%);
    opacity: 0;
  }
}
</style>
